import React from 'react';
import { TYPE, SURFACE } from '../ui/tokens';

/**
 * One figure, made dominant.
 *
 * "What is our total open PO value?" is a single number, and it used to arrive as 14px semibold in
 * a grid of identical tiles, indistinguishable from the label above it. The answer to a question
 * should be the largest thing in the answer.
 *
 * Reading order is label -> figure -> qualifier: what this is, what it is, what it is out of.
 * The figure arrives already formatted (the server owns money display), so this only sizes and
 * aligns it — `tabular-nums` so a column of these agrees down the page.
 */

export type MetricCardProps = {
  label: string;
  value: string | number;
  /** "23 open purchase orders" — what the figure is drawn from. */
  sub?: string | null;
  /** Draw as the single headline figure rather than one tile among several. */
  emphasis?: boolean;
};

export const MetricCard: React.FC<MetricCardProps> = ({ label, value, sub, emphasis = false }) => (
  <div
    className={[
      'border rounded-lg px-3 py-2.5',
      SURFACE.line,
      emphasis ? 'bg-primary-50 border-primary-500/30' : 'bg-slate-50',
    ].join(' ')}
  >
    <div className={`${TYPE.meta} text-slate-600 uppercase tracking-wide`}>{label}</div>
    <div className={[emphasis ? TYPE.metric : 'text-[22px] font-bold leading-tight tabular-nums', 'text-slate-900 mt-0.5'].join(' ')}>
      {value === null || value === undefined || value === '' ? '--' : value}
    </div>
    {sub ? <div className={`${TYPE.meta} text-slate-600 mt-0.5`}>{sub}</div> : null}
  </div>
);

export default MetricCard;
